import { Table, Tabs, Input, Button, Pagination, message, Popconfirm, Tooltip, TreeSelect, Select } from 'antd';
import { useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { commentList, conmentUpdate, auditorList, deleteComment } from "@/apis/comment";
import { useEffect } from 'react';
import React from 'react';

let typeList = []
const CommentAuditing = () => {
	const [auditList, setAuditList] = useState([])
	const [params, setParams] = useState({
		commentType: "OpenResource",
		keywords: "",
		auditStatus: 2,
		secondType: "",
		auditor: ""
	})
	const [pageParam, setPageParam] = useState({
		pageSize: 10,
		currentPage: 1,
	})
	const [data, setData] = useState([]);
	const [total, setTotal] = useState(0)
	const columns = [
		{
			title: "序号",
			key: 'index',
			width: 65,
			render: (text, record, index) => {
				return <div>{(pageParam.currentPage - 1) * 10 + index + 1}</div>
			},
		},
		{
			title: "评论时间",
			dataIndex: 'createTime',
			key: 'createTime',
			width: 170,
		},
		{
			title: "评论人",
			dataIndex: 'user',
			key: 'user',
			width: 140,
			render: (text, record) => (
				<div>{record.user ? record.user.nickname : ""}</div>
			),
		},
		{
			title: "评论",
			dataIndex: 'commentContent',
			key: 'commentContent',
			width: 400,
		},
		{
			title: "审核人",
			dataIndex: 'auditor',
			key: 'auditor',
			width: 140,
			render: (text, record) => (
				<div>{record.auditor.nickname ? record.auditor.nickname : "机审"}</div>
			),
		},
		{
			title: "审核时间",
			dataIndex: 'auditTime',
			key: 'auditTime',
			width: 170,
		},
		{
			title: "操作",
			key: 'opreation',
			render: (text, record) => {
				return <div>
					<Popconfirm
						title="评论驳回"
						description="是否确认继续执行此操作?"
						onConfirm={() => audit(record.commentUuid, 3)}
						okText="是"
						cancelText="否"
					>
						{params.auditStatus === 2 && <Button size="small">驳回</Button>}
					</Popconfirm>
					<Popconfirm
						title="评论通过"
						description="是否确认继续执行此操作?"
						onConfirm={() => audit(record.commentUuid, 2)}
						okText="是"
						cancelText="否"
					>
						{params.auditStatus === 3 && <Button style={{ marginLeft: 10 }} type="primary" size="small">通过</Button>}
					</Popconfirm>

					<Popconfirm
						title="删除评论"
						description="是否确认继续执行此操作?"
						onConfirm={() => deleteUuid(record.commentUuid)}
						okText="是"
						cancelText="否"
					>
						<Button style={{ marginLeft: 10 }} type="primary" size="small">删除</Button>
					</Popconfirm>
				</div>
			},
		},
	];

	const items = [
		{
			key: 2,
			label: '审核通过',
			children: '',
		}, {
			key: 3,
			label: '审核不通过',
			children: '',
		}
	];

	// 审核
	const audit = (id, status) => {
		conmentUpdate({
			commentUuid: id,
			auditStatus: status,
		}).then(res => {
			message.success('审核成功')
			getList()
		}).catch(err => { })
	}

	// 删除
	const deleteUuid = (uuid) => {
		deleteComment({
			commentUuid: uuid,
			commentType:"OpenResource"
		}).then(res => {
			message.success("删除成功")
			getList()
		})
	}

	const onChange = (key) => {
		setParams({ ...params, auditStatus: key })
		setPageParam({ ...pageParam, currentPage: 1 })
	}

	const getList = () => {
		commentList({
			...pageParam,
			...params,
		}).then(res => {
			setData(res.data?.records || [])
			setTotal(res.data?.total || 0)
		})
	}
	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			getList()
		}
	}
	useEffect(() => {
		auditorList().then(res => {
			let arr = res.data.map(item => {
				return {
					label: item.username,
					value: item.uuid
				}
			})
			arr.unshift({ label: "机审", value: "auto" })
			setAuditList(arr)
		})
	}, []);

	useEffect(() => {
		getList()
	}, [params, pageParam])

	return <div className={classNames('container', styles.dataAuditingBox)}>
		<h3>评论审核</h3>
		<Tabs type="card" defaultActiveKey={params.auditStatus} items={items} onChange={onChange} />
		<div className={styles.paramBox}>
			<span>标题：</span>
			<Input
				allowClear
				placeholder="资源名称"
				onKeyDown={handleKeyDown}
				className={styles.itemBox}
				onChange={(e) => {
					setParams({ ...params, keywords: e.target.value })
				}} />

			<span>资源类型：</span>
			<TreeSelect
				showSearch
				style={{
					width: '300px',
				}}
				value={params.secondType}
				fieldNames={{ label: 'label', value: 'value', children: 'children' }}
				placeholder="请选择"
				allowClear
				treeDefaultExpandAll={true}
				onChange={(e) => {
					setParams({ ...params, secondType: e })
				}}
				treeData={typeList}
			/>
			{
				params.auditStatus !== 1 && <React.Fragment>
					<span style={{ marginLeft: 20 }}>审核人：</span>
					<Select
						allowClear
						showSearch
						style={{ width: 220 }}
						options={auditList}
						optionFilterProp="label"
						onChange={(value) => {
							setParams({ ...params, auditor: value })
						}}
					>
					</Select>
				</React.Fragment>
			}
		</div>
		<Table rowKey={record => record.commentUuid} pagination={false} columns={columns} dataSource={data} />
		<Pagination
			align="end"
			style={{ marginTop: "20px" }}
			current={pageParam.currentPage}
			pageSize={pageParam.pageSize}
			total={total}
			showSizeChanger={false}
			showQuickJumper
			onChange={(page, pageSize) => {
				setPageParam({
					currentPage: page,
					pageSize: pageSize,
				});
			}}
		/>
	</div>
}
export default CommentAuditing;